import { TooltipDirective } from "@/directives/tooltip/tooltip.directive";
import { Component, Input, OnInit } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { MatIconModule } from "@angular/material/icon";
import { KpiChartDialogComponent } from "../kpi-chart-dialog/kpi-chart-dialog.component";

@Component({
  selector: "app-kpi",
  templateUrl: "./kpi.component.html",
  styleUrls: ["./kpi.component.scss"],
  standalone: true,
  imports: [MatIconModule, TooltipDirective],
})
export class KpiComponent implements OnInit {
  @Input() icon: string;
  @Input() value: string;
  @Input() title: string;
  @Input() details?: string;
  @Input() historyApiFunction: string;
  @Input() historyApiField: string;
  @Input() main = false;

  cssClass = "";

  constructor(private dialog: MatDialog) {}

  ngOnInit(): void {
    this.cssClass = this.main ? "main" : "";
    console.log(" title " + this.title + ", cssClass " + this.cssClass);
  }

  showHistory() {
    // prevents to open multiple dialog
    if (this.dialog.openDialogs.length === 0) {
      this.dialog.open(KpiChartDialogComponent, {
        // width: '25rem',
        data: {
          title: this.title,
          historyApiFunction: this.historyApiFunction,
          historyApiField: this.historyApiField,
        },
      });
    }
  }
}
